import { TItem } from "@/components/SortableList/SortableList";
import { TableColumn } from "@/components/Table/Table";

import { buildTableConfigItems } from "./buildTableConfigItems";

export const OTHER_LISTS_MIGRATION = "PREC-4185-other-lists";

/** Restore this default once per list, preserving subsequent user choices and all other entries. */
export const migrateTableConfig = (stored: TItem[], appliedMigrations: string[]): TItem[] => {
	const otherLists = stored.find((item) => item.uid === "otherLists");

	if (!otherLists || appliedMigrations.includes(OTHER_LISTS_MIGRATION)) {
		return stored;
	}

	const migrated = stored.filter((item) => item.uid !== "otherLists");
	const createdAtIndex = migrated.findIndex((item) => item.uid === "createdAt");
	const insertIndex = createdAtIndex < 0 ? stored.indexOf(otherLists) : createdAtIndex;

	migrated.splice(insertIndex, 0, { ...otherLists, show: true });

	return migrated;
};

/** The existing reset rules, extracted so the oversized table can wire in the migration. */
export const getTableConfigReset = (
	columns: TableColumn[],
	stored: TItem[],
	force = false
): TItem[] | undefined => {
	const candidate =
		stored.length > 0 && columns.length === stored.length ? stored : buildTableConfigItems(columns);
	const foundColumn =
		candidate.every((entry) => columns.find((column) => column.title === entry?.content)) &&
		columns.every((column) => candidate.find((entry) => entry.content === column.title)) &&
		stored.every((entry) => candidate.find((other) => other.content === entry.content)) &&
		candidate.every((entry) => stored.find((other) => other.content === entry.content));

	if (!foundColumn || stored.length === 0 || force) {
		return buildTableConfigItems(columns);
	}
};

/** Preserve the existing order-sensitive comparison used to skip unchanged server writes. */
export const areTableConfigsEqual = (
	current: Record<string, unknown>[],
	stored: Record<string, unknown>[]
): boolean => {
	if (current?.length !== stored?.length) {
		return false;
	}

	return current.every((entry, index) => {
		const other = stored[index];

		return !!other && Object.keys(entry).every((key) => entry[key] === other[key]);
	});
};
